/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./icon-wrapper.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var styles = {
  root: "_2rko1q5u _1reo15vq _18m915vq _189e1bk5 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
var unboundStyles = {
  root: "_1h6d1bhr"
};

/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */
var IconWrapper = function IconWrapper(_ref) {
  var bgColor = _ref.bgColor,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("span", {
    role: "presentation",
    style: {
      borderColor: bgColor,
      backgroundColor: bgColor
    },
    className: ax([styles.root, unboundStyles.root])
  }, children);
};
export default IconWrapper;